/**
 * Global date formatting utilities — DD/MM/YYYY for EU/Cyprus.
 * All date display across the app must use these functions.
 */

/**
 * Format ISO date string (YYYY-MM-DD) to DD/MM/YYYY.
 * Returns '-' for empty/null values.
 */
export const formatDateDMY = (d) => {
  if (!d) return '-';
  const str = typeof d === 'string' ? d : d.toISOString?.() || String(d);
  const dateOnly = str.split('T')[0];
  const parts = dateOnly.split('-');
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return str;
};

/**
 * Format a Date object or ISO string to DD/MM/YYYY HH:MM.
 * For timestamps (created_at, updated_at, etc.)
 */
export const formatDateTimeDMY = (d) => {
  if (!d) return '-';
  try {
    const dt = typeof d === 'string' ? new Date(d) : d;
    if (isNaN(dt.getTime())) return '-';
    const day = String(dt.getDate()).padStart(2, '0');
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const year = dt.getFullYear();
    const hours = String(dt.getHours()).padStart(2, '0');
    const mins = String(dt.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${mins}`;
  } catch {
    return String(d);
  }
};

/**
 * Get today's date in ISO format (YYYY-MM-DD) for form defaults.
 */
export const todayISO = () => new Date().toISOString().split('T')[0];
